import {
  useDashboardJobs,
  useTalentSearchContext,
} from 'src/modules/ApiClient';
import type { HeroMode } from 'src/types';
import { heroVariantSelector } from 'src/utils/heroVariantSelector';

export const useHeroVariant = (): HeroMode => {
  const { data: tsContext } = useTalentSearchContext();
  const { data: jobsInfo } = useDashboardJobs();

  return heroVariantSelector({
    tsContext,
    jobsInfo,
  });
};
